import type { PublicApiKey } from '@/apilib';
import type { createPromotionsApi } from './promotionsWrapper';

export const PromotionsApiKey: PublicApiKey<typeof createPromotionsApi> = {
  name: 'PromotionsApi',
  public: true,
};
